(function() {
    const slider = document.querySelector('#product-media-section .swiper');
    const videos = slider.querySelectorAll('.swiper-slide.video-slide');

    if(!slider) {
        return;
    }

    initSlider();

    function initSlider() {
        if(typeof Swiper === 'undefined') {
            return setTimeout(initSlider, 200);
        }

        slider.swiper = new Swiper(slider, {
            centeredSlides: false,
            loop: false,
            draggable: true,
            slidesPerView: 'auto',
            spaceBetween: 26,
            breakpoints: {
                // when window width is >= 320px
                0: {
                    loop: true,
                    centeredSlides: true,
                    spaceBetween: 10
                },
                769: {
                    loop: false,
                    centeredSlides: false,
                    spaceBetween: 20
                },
                // when window width is >= 1920px
                1920: {
                    loop: false,
                    centeredSlides: false,
                    spaceBetween: 26
                }
            }
        });

        videos.forEach(slide => {
            const video = slide.querySelector('video');

            if(!video) {
                return;
            }

            slide.addEventListener('click', function () {
                if (video.paused) {
                    slide.classList.add('is-playing');

                    video.play();
                } else {
                    slide.classList.remove('is-playing');

                    video.pause();
                }
            });
        });
    }
})();